module.exports = __webpack_public_path__ + "img/9788992711135.283f314d.jpg";